// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * \`--px\` is 1/Nth of the canvas's actual rendered width (a container query unit, not the viewport) -
 * every widget/floater dimension is \`calc(var(--px) * <spec px value>)\`, so the whole cluster scales as
 * one unit to fit whatever width the hero column gives it, instead of overflowing at narrow widths.
 */
.canvas__HeroWidgets-module--boFPX {
    position: relative;
    margin: 0 auto;
    container-type: inline-size;
}

.canvasMobile__HeroWidgets-module--TouAx {
    width: min(100%, 350px);
    aspect-ratio: 350 / 680;
    --px: 0.2857142857cqw;
}

.canvasDesktop__HeroWidgets-module--O5zL6 {
    width: min(100%, 640px);
    aspect-ratio: 640 / 760;
    --px: 0.15625cqw;
    display: none;
}

@media (min-width: 1024px) {
    .canvasMobile__HeroWidgets-module--TouAx {
        display: none;
    }

    .canvasDesktop__HeroWidgets-module--O5zL6 {
        display: block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/HeroWidgets.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,kBAAkB;IAClB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/*\n * `--px` is 1/Nth of the canvas's actual rendered width (a container query unit, not the viewport) -\n * every widget/floater dimension is `calc(var(--px) * <spec px value>)`, so the whole cluster scales as\n * one unit to fit whatever width the hero column gives it, instead of overflowing at narrow widths.\n */\n.canvas {\n    position: relative;\n    margin: 0 auto;\n    container-type: inline-size;\n}\n\n.canvasMobile {\n    width: min(100%, 350px);\n    aspect-ratio: 350 / 680;\n    --px: 0.2857142857cqw;\n}\n\n.canvasDesktop {\n    width: min(100%, 640px);\n    aspect-ratio: 640 / 760;\n    --px: 0.15625cqw;\n    display: none;\n}\n\n@media (min-width: 1024px) {\n    .canvasMobile {\n        display: none;\n    }\n\n    .canvasDesktop {\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canvas": `canvas__HeroWidgets-module--boFPX`,
	"canvasMobile": `canvasMobile__HeroWidgets-module--TouAx`,
	"canvasDesktop": `canvasDesktop__HeroWidgets-module--O5zL6`
};
export default ___CSS_LOADER_EXPORT___;
